import router from '@router'
import axios from 'axios'
import ENV from '@src/env'

import firebase from 'firebase/app'
import 'firebase/database'

import Raven from 'raven-js'
import AMPLITUDE from '@constants/amplitude'
import GTM_CONSTANTS from '@constants/google-tag-manager'

import { keysToCamel } from '../../utils/object-utils'
require('firebase/auth')

export let database

export const state = {
  firebaseRootURL: {},
  firebaseToken: {},
  firebaseTicketScreen: {},
}

export const getters = {
  getFirebaseToken(state) {
    return state.firebaseToken.access_token || ''
  },
  widgetsCommon(state, getters, rootState) {
    const { common } = rootState.widgets
    return common || {}
  },
  getFirebaseRootURL(state) {
    const { firebaseRootURL } = state
    return firebaseRootURL.length > 0 ? firebaseRootURL[0].url : ''
  },
  getFirebaseTicketScreenData(state) {
    return state.firebaseTicketScreen || {}
  },
  getFirebaseScreenId(state) {
    const { firebaseTicketScreen } = state
    return firebaseTicketScreen.screenId ? firebaseTicketScreen.screenId : null
  },
  userData(state, getters, rootState) {
    const { data, common } = rootState.widgets
    const info = data.SharedData ? data.SharedData.userData : {}
    const meta = common.user ? common.user : {}
    return Object.assign({}, info, meta)
  },
  getChildPathURL(state, getters, rootState, rootGetters) {
    const { widgetsCommon } = getters
    return rootGetters['widgets/userEnv'] === 'DEV'
      ? `dev/orders/${widgetsCommon.query.order_id}/ticket_screen`
      : `${widgetsCommon.query.country_code}/orders/${widgetsCommon.query.order_id}/ticket_screen`
  },
  getFirebaseConfig(state, getters, rootState, rootGetters) {
    return rootGetters['widgets/userEnv'] === 'DEV'
      ? ENV.firebase.DEV
      : ENV.firebase.PROD
  },
}

export const mutations = {
  ADD_FIREBASE_ROOT_URL(state, data) {
    state.firebaseRootURL = data
  },
  ADD_FIREBASE_TOKEN(state, data) {
    state.firebaseToken = data
  },
  ADD_FIREBASE_TICKET_SCREEN(state, data) {
    state.firebaseTicketScreen = data
  },
}

export const actions = {
  async getFirebaseDatabaseURLS({ commit, getters, rootGetters, dispatch }) {
    const { widgetsCommon } = getters

    try {
      const baseFirebase = `${
        ENV.rappi.url[rootGetters['widgets/userEnv']]
      }/realtime-interface/databases`

      const {
        data: { data },
      } = await axios.get(baseFirebase, {
        headers: {
          Authorization: `Bearer ${widgetsCommon.query.token}`,
        },
      })

      const onlySwapUrl = data.filter(db => db.name === 'SWAP_SCREENS')

      await commit('ADD_FIREBASE_ROOT_URL', onlySwapUrl)
      await dispatch('firebaseAuth')
    } catch (error) {
      Raven.captureException(error)
    }
  },
  async firebaseAuth({ commit, getters, rootGetters }) {
    const { widgetsCommon } = getters
    try {
      const baseFirebaseAuth = `${
        ENV.rappi.url[rootGetters['widgets/userEnv']]
      }/realtime-interface/firebase/login`

      const { data } = await axios.get(baseFirebaseAuth, {
        headers: {
          Authorization: `Bearer ${widgetsCommon.query.token}`,
        },
      })
      commit('ADD_FIREBASE_TOKEN', data)
    } catch (error) {
      Raven.captureException(error)
    }
  },
  async initializeFirebase({ commit, getters, state, rootGetters }) {
    const {
      widgetsCommon,
      getFirebaseConfig,
      getFirebaseRootURL,
      getFirebaseToken,
      getChildPathURL,
      userData,
    } = getters

    try {
      if (!firebase.apps.length) {
        database = firebase
          .initializeApp({
            ...getFirebaseConfig,
            databaseURL: getFirebaseRootURL,
          })
          .database()
      }

      await firebase
        .auth()
        .signInWithCustomToken(getFirebaseToken)
        .catch(error => {
          this.dataLayerPush({
            user: userData,
            event: GTM_CONSTANTS.LOG_EVENT,
            eventType: AMPLITUDE.FIREBASE_AUTH_FAILED,
            payload: error,
          })
          Raven.captureException(error)
        })

      await database.ref(getChildPathURL).on('value', snapshot => {
        if (snapshot.val()) {
          const { conversationId, orderId, screenId } =
            keysToCamel(snapshot.val()) || {}
          commit('ADD_FIREBASE_TICKET_SCREEN', {
            conversationId,
            orderId,
            screenId: screenId && screenId.toUpperCase(),
          })
        } // PUEDE SER NULL SI NO TIENE VALOR
      })

      await new Promise(resolve => {
        setTimeout(() => {
          firebase.database().goOffline()
          resolve()
        }, 5000)
      })
      if (getters.getFirebaseScreenId) {
        this.dataLayerPush({
          user: userData,
          event: GTM_CONSTANTS.LOG_EVENT,
          eventType: AMPLITUDE.FIREBASE_GET_SCREEN,
          payload: {
            data: getters.getFirebaseScreenId,
          },
        })
        router.push({
          name: 'screen',
          params: {
            screenId: getters.getFirebaseScreenId,
          },
          query: widgetsCommon.query,
        })
      } else {
        this.dataLayerPush({
          user: userData,
          event: GTM_CONSTANTS.LOG_EVENT,
          eventType: AMPLITUDE.FIREBASE_GET_SCREEN_ERROR,
          payload: { data: getters.getFirebaseScreenId },
        })

        router.push({
          name: 'screen',
          params: {
            screenId: 'MANAGED_BY_AGENT',
          },
          query: widgetsCommon.query,
        })
      }
    } catch (error) {
      Raven.captureException(error)
      this.dataLayerPush({
        user: userData,
        event: GTM_CONSTANTS.LOG_EVENT,
        eventType: AMPLITUDE.FIREBASE_GET_SCREEN_ERROR,
        payload: { data: getters.getFirebaseScreenId },
      })

      router.push({
        name: 'screen',
        params: {
          screenId: 'MANAGED_BY_AGENT',
        },
        query: widgetsCommon.query,
      })
    }
  },
}
